import { PROCESS_ORDER_ITEMS, RECEIVE_LABELS } from '../../actions/orderItems';

export const initialState = {
  allItems: [],
  eligibleItems: [],
  ineligibleItems: [],
  labels: [],
  labelItemCount: 0,
};

export default (
  state = initialState,
  { type, data: { allItems, eligibleItems, ineligibleItems, labels, labelItemCount } = {} } = {},
) => {
  switch (type) {
    case PROCESS_ORDER_ITEMS:
      return {
        ...state,
        allItems,
        eligibleItems,
        ineligibleItems,
      };

    case RECEIVE_LABELS:
      return {
        ...state,
        labels,
        labelItemCount,
      };

    default:
      return state;
  }
};
